module.exports = __webpack_public_path__ + "img/diamond.9cf4a062.png";